import { render } from "./EditarVoucher.vue?vue&type=template&id=24387d1e&scoped=true"
import script from "./EditarVoucher.vue?vue&type=script&lang=js"
export * from "./EditarVoucher.vue?vue&type=script&lang=js"

import "./EditarVoucher.vue?vue&type=style&index=0&id=24387d1e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24387d1e"]])

export default __exports__